import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getCookie, setUserTokenCookie } from '../utils/cookies';
import { useState } from 'react';
import { CircularProgress } from '@mui/material';

export default function Login() {
	const navigate = useNavigate();
  const [progress, setProgress] = useState(false);
  const [err, setErr] = useState(false);

	React.useEffect(() => {
		if(getCookie('usertoken'))
			navigate('/main')
	}, [])

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form_data = new FormData(event.currentTarget);
    setProgress(true)
    try {
        const { data } = await axios.post(`https://salesleads.fairshare.tech/server/login`, form_data)
				setUserTokenCookie(data.token)
        navigate('/main')
    } catch (err: any) {
			console.log(err)
      setErr(true)
		}
    setProgress(false)
  };

  return (
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              error={err}
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              error={err}
              type="password"
              id="password"
              autoComplete="current-password"
            />
            {progress?(
              <CircularProgress thickness={7.5} sx={{ alignSelf: 'center' }}/>
            ):(
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            )}
            {/* <Grid container>
              <Grid item>
                <Link href="/register" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid> */}
          </Box>
        </Box>
      </Container>
  );
}